var map = {
	"./de.json": "9193",
	"./el.json": "4b84",
	"./en.json": "77de",
	"./es.json": "9576",
	"./fr.json": "a9e74",
	"./gb.json": "d3bb",
	"./it.json": "b59c",
	"./pl.json": "ceb7",
	"./pt.json": "4fcd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b1d9";